import { render } from "./AcademyTriangle.vue?vue&type=template&id=197a8344"
import script from "./AcademyTriangle.vue?vue&type=script&lang=js"
export * from "./AcademyTriangle.vue?vue&type=script&lang=js"

import "./AcademyTriangle.vue?vue&type=style&index=0&id=197a8344&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__